import React, { useEffect, useState } from 'react';
import UIBody from '../../../components/ui/UIBody';
import { Link } from 'react-router-dom';
import { FaDesktop, FaTools, FaRobot, FaSmile, FaBullseye, FaBook, FaRocket, FaStar, FaPuzzlePiece, FaReact } from 'react-icons/fa'; // Import react-icons
import useApiCallHooks from '../../../hooks/useApiCallHooks';

const Roboticsyllabus = () => {
   const [responce, loading, error, callAPI, statusCode] = useApiCallHooks();
const[courses,setCourse]=useState([]);
  const stats = [
    { icon: <FaDesktop className="react-icon" style={{ color: '#fff' }} />, count: "5", label: "Grade Levels" },
    { icon: <FaTools className="react-icon" style={{ color: '#fff' }} />, count: "50+", label: "Fun Projects" },
    { icon: <FaRobot className="react-icon" style={{ color: '#fff' }} />, count: "15+", label: "Robot Kits" },
    { icon: <FaSmile className="react-icon" style={{ color: '#fff' }} />, count: "1000+", label: "Happy Students" }
  ];
  

useEffect(() => {
  callAPI("get", "robotics-syllabus");
}, []);

useEffect(() => {
if(statusCode===200){
setCourse(responce.data)
}}, [statusCode]);
  return (
    <UIBody
    loading={loading}
      content={
        <>
          <section className="cta__area-four">
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-xl-10" >
                  <div className="cta__inner-wrap mt-2" style={{
    background: 'linear-gradient(92deg, rgba(42, 123, 155, 1) 0%, rgba(87, 199, 133, 1) 50%, rgba(237, 221, 83, 1) 100%)',
    borderRadius: '20px',
    color: '#fff',
  }}>
                    <div className="cta__img-three tg-svg">
                      <img
                        src="https://html.themegenix.com/skillgro/assets/img/others/h8_cta_img.png"
                        alt="img"
                      />
                      <span
                        className="svg-icon"
                        id="cta-svg"
                        data-svg-icon="assets/img/others/h8_cta_img_shape.svg"
                      ></span>
                    </div>
                    <div className="cta__content-three cta__content-four">
                      <div className="content__left">
                        <h2 className="title">Start Your Robotics Journey Today</h2>
                        <p>
                          Discover hands-on robotics kits and expert-guided projects designed to spark innovation and tech skills in students — all in one place.
                        </p>
                      </div>
                    
                    </div>
                    <img
                      src="assets/img/others/h8_cta_shape.svg"
                      alt="shape"
                      className="shape"
                    />
                  </div>
                </div>
              </div>
            </div>
          </section>
          <div className="section__title text-center mb-40 mt-5">
            <span className="sub-title" style={{ color: '#004aad' }}>Growth Zone</span>
            <h2 className="title">Learning Journey by Grade</h2>
            <p className="desc">
              Our comprehensive curriculum grows with your child,
              introducing age-appropriate concepts and <br />exciting hands-on
              projects that build essential STEM skills for the future! <FaStar className="react-icon" style={{ color: '#004aad' }} />
            </p>
          </div>

          <div className="container py-5">
            <div className="row">
              {courses.map((course, index) => (
                <div key={index} className="col-md-4 mb-4">
                  <div className="card y-card h-100 position-relative card-hover">
                    <div
                      className="y-card-header"
                      style={{
                        background: 'linear-gradient(to right, #004aad, #4a90e2)',
                        transition: 'all 0.3s ease-in-out'
                      }}
                    >
                      <div>
                        <h5 className="y-grade-title text-white">{course.class}</h5>
                        <p className="y-age-range text-white">{course.age}</p>
                        <p className="y-level text-white">{course.level}</p>
                      </div>
                      {course.tag && (
                        <span className="y-badge-popular bg-accent text-white">{course.tag}</span>
                      )}
                    </div>

                    <div className="card-body">
                      <div className="y-pricing d-flex justify-content-between align-items-center">
                        {course.price}.Rs
                        <span className="courses__item-tag courses__item-content courses__item-meta list-wrap" style={{ backgroundColor: '#00c4cc', color: 'white' }}>
                          {course.level}
                        </span>
                      </div>

                      <div className="y-section-title" style={{ color: '#004aad' }}>
                        <FaBullseye className="react-icon me-2" style={{ color: '#004aad' }} /> Theory
                      </div>
                      <div>
                        <ul className="list-unstyled ms-3">
                          {course.theory.map((item, i) => (
                            <li key={i} className="mb-2">
                              <i className="fas fa-check-circle text-success me-2"></i> {item}
                            </li>
                          ))}
                        </ul>
                      </div>

                      <div className="y-section-title" style={{ color: '#004aad' }}>
                        <FaBook className="react-icon me-2" style={{ color: '#004aad' }} /> Practical
                      </div>
                      <div>
                        <ul className="y-list list-unstyled">
                          {course.practical.map((item, i) => (
                            <li key={i}>
                              <i className="fas fa-check-circle text-success me-2"></i> {item}
                            </li>
                          ))}
                        </ul>
                      </div>

                      <div className="y-section-title" style={{ color: '#004aad' }}>
                        <FaRocket className="react-icon me-2" style={{ color: '#004aad' }} /> Projects
                      </div>
                      <div className="d-flex flex-wrap gap-2">
                        {course.project.map((kit, i) => (
                          <span key={i} className="badge bg-light border text-dark">
                            {kit}
                          </span>
                        ))}
                      </div>

                      <Link to="/robotical-register">
                        <button
                          className="btn w-100 rounded mt-2 btn-hover"
                          style={{ background: 'linear-gradient(to right, #004aad, #4a90e2)', color: 'white' }}
                        >
                          Enroll Now
                        </button>
                      </Link>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div
            className="stats-section text-white text-center py-5"
            style={{ background: 'linear-gradient(to bottom, #004aad, #00c4cc)' }}
          >
            <h2 className="fw-bold state-h1">
              Amazing Learning Journey <FaPuzzlePiece className="react-icon" style={{ color: '#4a90e2' }} />
            </h2>
            <p className="mb-5 text-white">Join our growing community of young innovators!</p>

            <div className="container">
              <div className="row justify-content-center">
                {stats.map((stat, index) => (
                  <div className="col-6 col-md-3 mb-4" key={index}>
                    <div className="stat-circle d-flex flex-column align-items-center justify-content-center mx-auto">
                      <div className="icon text-white fs-2 react-icon">{stat.icon}</div>
                      <h4 className="fw-bold text-white ">{stat.count}</h4>
                    </div>
                    <p className="mt-2 text-white">{stat.label}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Styles */}
          <style>{`
            .y-card {
              border: none;
              border-radius: 10px;
              overflow: hidden;
            }
            .y-card-header {
              padding: 20px;
              display: flex;
              justify-content: space-between;
              align-items: center;
            }
            .y-grade-title {
              font-size: 1.5rem;
              margin-bottom: 5px;
            }
            .y-age-range, .y-level {
              margin: 0;
              font-size: 0.9rem;
            }
            .y-badge-popular {
              background: linear-gradient(to right, #4a90e2, #00c4cc);
              padding: 5px 10px;
              border-radius: 12px;
              font-size: 0.8rem;
              transition: all 0.3s ease-in-out;
            }
            .y-badge-popular:hover {
              transform: scale(1.05);
            }
            .y-pricing {
              font-size: 1.2rem;
              font-weight: bold;
              margin-bottom: 20px;
            }
            .y-section-title {
              font-size: 1.1rem;
              font-weight: 600;
              margin-top: 15px;
              margin-bottom: 10px;
              display: flex;
              align-items: center;
            }
            .y-list li {
              margin-bottom: 10px;
              font-size: 0.9rem;
            }
            .card-hover {
              transition: transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out;
            }
            .card-hover:hover {
              transform: translateY(-5px);
              box-shadow: 0 10px 20px rgba(0, 74, 173, 0.2);
            }
            .btn-hover {
              transition: all 0.3s ease-in-out;
            }
            .btn-hover:hover {
              transform: translateY(-2px);
              background: linear-gradient(to right, #003180, #357abd);
            }
            .stat-circle {
              width: 150px;
              height: 150px;
              border-radius: 50%;
              background: linear-gradient(to right, #004aad, #4a90e2);
              transition: transform 0.3s ease-in-out;
            }
            .stat-circle:hover {
              transform: scale(1.1);
            }
            .react-icon {
              transition: transform 0.3s ease-in-out;
            }
            .react-icon:hover {
              transform: rotate(360deg);
            }
            .courses__item-tag {
              padding: 5px 10px;
              border-radius: 12px;
              font-size: 0.8rem;
              transition: all 0.3s ease-in-out;
            }
            .courses__item-tag:hover {
              transform: scale(1.05);
            }
          `}</style>
        </>
      }
    />
  );
};

export default Roboticsyllabus;